import React, { Component } from 'react';
import { trackPauseAnyTimeSellingPoint } from '../../tracking/event';

class PauseAnyTimeSellingPoint extends Component {
  constructor(props) {
    super(props);
    this.toggleExpandedText = this.toggleExpandedText.bind(this);
    this.state = {
      textExpanded: false,
    };
  }

  toggleExpandedText() {
    trackPauseAnyTimeSellingPoint();
    this.setState({ textExpanded: !this.state.textExpanded });
  }

  render() {
    const someOneOrWhere =
      this.props.productType == 'bold' ? 'someone' : 'somewhere';
    const expandedText = this.state.textExpanded ? (
      <span
        id="pauseAnyTimeText"
        className="product-selector__selling-point-expanded-content"
      >
        If you manage to find {someOneOrWhere} in, say, 2 weeks, simply pause
        your advertising for another time (your access can only be paused once
        and must all be used within 1 year)
      </span>
    ) : null;
    return (
      <React.Fragment>
        <button
          aria-expanded={this.state.textExpanded ? 'true' : 'false'}
          aria-controls="pauseAnyTimeText"
          type="button"
          className="button button--link product-selector__selling-point-expand"
          onClick={this.toggleExpandedText}
        >
          Pause your upgrade
        </button>{' '}
        {this.props.sellingPoint}
        {expandedText}
      </React.Fragment>
    );
  }
}

export default PauseAnyTimeSellingPoint;
